/**
 * CTS Backend
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient';
import BookBaseDto from './BookBaseDto';

/**
 * The BookListIsCheckedDto model module.
 * @module model/BookListIsCheckedDto
 * @version v1.0.0
 */
class BookListIsCheckedDto {
    /**
     * Constructs a new <code>BookListIsCheckedDto</code>.
     * @alias module:model/BookListIsCheckedDto
     */
    constructor() { 
        
        BookListIsCheckedDto.initialize(this);
    }

    /**
     * Initializes the fields of this object.
     * This method is used by the constructors of any subclasses, in order to implement multiple inheritance (mix-ins).
     * Only for internal use.
     */
    static initialize(obj) { 
    }

    /**
     * Constructs a <code>BookListIsCheckedDto</code> from a plain JavaScript object, optionally creating a new instance.
     * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
     * @param {Object} data The plain JavaScript object bearing properties of interest.
     * @param {module:model/BookListIsCheckedDto} obj Optional instance to populate.
     * @return {module:model/BookListIsCheckedDto} The populated <code>BookListIsCheckedDto</code> instance.
     */
    static constructFromObject(data, obj) {
        if (data) {
            obj = obj || new BookListIsCheckedDto();

            if (data.hasOwnProperty('book')) {
                obj['book'] = ApiClient.convertToType(data['book'], [BookBaseDto]);
            }
            if (data.hasOwnProperty('bookCount')) {
                obj['bookCount'] = ApiClient.convertToType(data['bookCount'], 'Number');
            }
            if (data.hasOwnProperty('bookInventoryTotal')) {
                obj['bookInventoryTotal'] = ApiClient.convertToType(data['bookInventoryTotal'], 'Number');
            }
            if (data.hasOwnProperty('description')) {
                obj['description'] = ApiClient.convertToType(data['description'], 'String');
            }
            if (data.hasOwnProperty('id')) {
                obj['id'] = ApiClient.convertToType(data['id'], 'Number');
            }
            if (data.hasOwnProperty('isChecked')) {
                obj['isChecked'] = ApiClient.convertToType(data['isChecked'], 'Boolean');
            }
            if (data.hasOwnProperty('status')) {
                obj['status'] = ApiClient.convertToType(data['status'], 'String');
            }
            if (data.hasOwnProperty('title')) {
                obj['title'] = ApiClient.convertToType(data['title'], 'String');
            }
        }
        return obj;
    }


}

/**
 * @member {Array.<module:model/BookBaseDto>} book
 */
BookListIsCheckedDto.prototype['book'] = undefined;

/**
 * @member {Number} bookCount
 */
BookListIsCheckedDto.prototype['bookCount'] = undefined;

/**
 * @member {Number} bookInventoryTotal
 */
BookListIsCheckedDto.prototype['bookInventoryTotal'] = undefined;

/**
 * @member {String} description
 */
BookListIsCheckedDto.prototype['description'] = undefined;

/**
 * @member {Number} id
 */
BookListIsCheckedDto.prototype['id'] = undefined;

/**
 * @member {Boolean} isChecked
 */
BookListIsCheckedDto.prototype['isChecked'] = undefined;

/**
 * @member {module:model/BookListIsCheckedDto.StatusEnum} status
 */
BookListIsCheckedDto.prototype['status'] = undefined;

/**
 * @member {String} title
 */
BookListIsCheckedDto.prototype['title'] = undefined;





/**
 * Allowed values for the <code>status</code> property.
 * @enum {String}
 * @readonly
 */
BookListIsCheckedDto['StatusEnum'] = {

    /**
     * value: "Draft"
     * @const
     */
    "Draft": "Draft",

    /**
     * value: "Publish"
     * @const
     */
    "Publish": "Publish"
};



export default BookListIsCheckedDto;

